import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import useProfileEditorDialog from '../../hooks/useProfileEditorDialog';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { EditAddressForm } from '../profile/EditAddressForm';
import { CreateNewAddresses } from '../profile/CreateNewAddresses';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import AddressService from '../../services/AddressService';
import SnackbarUtils from '../../utils/SnackbarUtils';
import StyledTitle from '../styled/Dialog/StyledTitle';

const AddressesEditorDialog: React.FC<{ open: boolean }> = (props) => {
    const profileDialog = useProfileEditorDialog();
    const { t } = useTranslation();
    const [submitIsLoading, setSubmitIsLoading] = useState(false);

    const convertData = (data) => {
        return {
            companyAddress: {
                type: profileDialog.selectedAddressStates.type.toUpperCase(),
                ...data,
            },
        };
    };

    const convertNewData = (data) => {
        return {
            companyAddress: {
                // billingAddress: {
                //     address1: data.same_as_shipping
                //         ? data.address1
                //         : data.billing_address1,
                //     address2: data.same_as_shipping
                //         ? data.address2
                //         : data.billing_address2,
                //     city: data.same_as_shipping ? data.city : data.billing_city,
                //     country: data.same_as_shipping
                //         ? data.country
                //         : data.billing_country,
                //     phone: data.same_as_shipping
                //         ? data.phone
                //         : data.billing_phone,
                //     postcode: data.same_as_shipping
                //         ? data.postcode
                //         : data.billing_postcode,
                // },
                shippingAddress: {
                    address1: data.address1,
                    address2: data.address2,
                    city: data.city,
                    country: data.country,
                    phone: data.phone,
                    postcode: data.postcode,
                },
            },
        };
    };

    const handleClose = () => {
        profileDialog.setSelectedAddress(null);
        profileDialog.closeAllDialog();
    };

    const handleFormSubmitClose = (data) => {
        setSubmitIsLoading(true);
        AddressService.updateAddress(
            profileDialog.selectedAddressStates.id,
            convertData(data)
        )
            .then(() => {
                SnackbarUtils.success(
                    t('NOTIFICATION.ADDRESS_EDITED').toString()
                );
                profileDialog.setAddressDialogClosedWithSuccess(true);
                handleClose();
            })
            .catch(() => {})
            .finally(() => {
                setSubmitIsLoading(false);
            });
    };

    const handleFormSubmitCreate = (data) => {
        setSubmitIsLoading(true);
        AddressService.createNewAddresses(convertNewData(data))
            .then(() => {
                SnackbarUtils.success(
                    t('NOTIFICATION.NEW_ADDRESS_CREATED').toString()
                );
                profileDialog.setAddressDialogClosedWithSuccess(true);
                handleClose();
            })
            .catch(() => {
                setSubmitIsLoading(false);
            })
            .finally(() => {
                setSubmitIsLoading(false);
            });
    };

    const setTitle = () => {
        return profileDialog.selectedAddressStates &&
            profileDialog.selectedAddressStates.type
            ? profileDialog.selectedAddressStates.type == 'shipping'
                ? t('PROFILE.PROFILE_DIALOG.TITLE_EDIT_SHIPPING')
                : t('PROFILE.PROFILE_DIALOG.TITLE_EDIT_BILLING')
            : t('PROFILE.PROFILE_DIALOG.TITLE_NEW_ADDRESS');
    };

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            maxWidth={'sm'}
            fullWidth
        >
            <StyledDialogTitle>
                <StyledTitle>{setTitle()}</StyledTitle>
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
            </StyledDialogTitle>
            <StyledDialogContent>
                {profileDialog.selectedAddressStates != null && (
                    <EditAddressForm
                        address={profileDialog.selectedAddressStates}
                        submitForm={handleFormSubmitClose}
                        setIsLoading={submitIsLoading}
                    />
                )}
                {profileDialog.selectedAddressStates == null && (
                    <CreateNewAddresses
                        submitForm={handleFormSubmitCreate}
                        setIsLoading={submitIsLoading}
                    />
                )}
            </StyledDialogContent>
        </Dialog>
    );
};

export default AddressesEditorDialog;
